import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import * as listActions from '../codesList/actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import store from '../../../store';

function* deleteCodeBulk({ payload: { codes, type, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.codes.bulk_remove, data: { codes } });

    dispatch(listActions.getCodesRequest({ type, curr_page: getState().getCodes.curr_page, filters: getState().getCodes.filters }));

    onSuccess && onSuccess();
    yield put(actions.deleteCodeBulkDone(data.results));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.deleteCodeBulkFailed,
      endpoint: api.codes.bulk_remove.url
    });
  }
}

export const deleteCodeBulkSaga = takeEvery(types.DELETE_CODE_BULK_REQUEST, deleteCodeBulk);